export default "__VITE_ASSET__27f61c5b__"